import {
  createDefaultLeadForm,
  type ReadLeadForm,
  type UpdateLeadForm,
} from '@tinct/core-api-models';

/**
 * Coerce the (all-nullable) read shape into an editable PUT draft, falling
 * back to the backend's disabled defaults for anything missing.
 */
export function readLeadFormToUpdate(read: ReadLeadForm | undefined): UpdateLeadForm {
  const defaults = createDefaultLeadForm();
  if (!read) return defaults;
  return {
    enabled: read.enabled ?? defaults.enabled,
    destination: read.destination ?? defaults.destination,
    fields:
      read.fields && read.fields.length > 0
        ? read.fields.map((field, index) => ({
            key: field.key ?? `field_${index + 1}`,
            label: field.label ?? '',
            type: field.type ?? 'text',
            required: field.required ?? false,
          }))
        : defaults.fields,
    successMessage: read.successMessage ?? defaults.successMessage,
  };
}
